import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/tradepassport-empty-thumbnail.png'


const _hoisted_1 = { class: "tw-flex tw-gap-3 tw-items-center" }
const _hoisted_2 = { class: "tw-w-full" }
const _hoisted_3 = { class: "tw-flex tw-items-start tw-gap-3 tw-w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tw-min-w-[68px] tw-w-[68px] tw-h-[68px] tw-rounded-[4.85px] tw-bg-[rgba(12,15,74,0.04)] tw-border-solid tw-border-[#DFDFDF] tw-border-[1px] tw-overflow-hidden" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "tw-w-full tw-h-full tw-object-cover"
  })
], -1)
const _hoisted_5 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-[.1rem] tw-items-start" }
const _hoisted_6 = { class: "tw-flex tw-items-start tw-gap-2" }

import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import TradePassportCardSlot from "../slots/TradePassportCardSlot.vue";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import BlueCircularPencilIcon from "@/core/components/icons/BlueCircularPencilIcon.vue";
import { UserVerificationStatusEnum } from "@/core/enums/RolesEnum";
import {
  getImageStringToImageURL,
  isExpiredDate,
  setDirectStoragePathToImage,
} from "@/core/utils/common";
import PendingChip from "@/modules/dashboard/components/Chips/PendingChip.vue";
import AcceptChip from "@/modules/dashboard/components/Chips/AcceptChip.vue";
import RejectChip from "@/modules/dashboard/components/Chips/RejectChip.vue";
import appFilters from "@/filters";
import { USER_STORE } from "@/store/modules/user";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { TRADE_PASSPOSRT_DETAILS_ROUTE } from "../../routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePassportInsurances',
  props: ["userInsurances"],
  setup(__props) {

const store = useStore();
const router = useRouter();

const props = __props;

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);

const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);

const onRouteToInsuranceOverview = () => {
  router.push({
    name: TRADE_PASSPOSRT_DETAILS_ROUTE,
    params: { type: "insurance" },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TradePassportCardSlot, {
    class: "trade-passport-insurance",
    title: "Insurance",
    buttonLabel: "+Add Insurance",
    hideFooter: props.userInsurances && props.userInsurances.length <= 3,
    emptyStateImage: "insurance-empty-state",
    emptyStateLabel: 
      isUserProprtyOwner.value
        ? 'Insurance details will appear here'
        : 'Your Insurance details will appear here'
    ,
    isEmpty: !props.userInsurances.length,
    numberOfRemainingItem: props.userInsurances.length,
    isCustomActionHeader: props.userInsurances && props.userInsurances.length,
    onOnHandleFooterClick: onRouteToInsuranceOverview,
    onOnHandleClick: onRouteToInsuranceOverview
  }, {
    "custom-action-header": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!isUserProprtyOwner.value)
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              label: "+Add",
              variant: "secondary",
              class: "!tw-w-auto md:!tw-min-h-[unset] md:!tw-px-2",
              onClick: onRouteToInsuranceOverview
            }))
          : _createCommentVNode("", true),
        (!isUserProprtyOwner.value)
          ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
              key: 1,
              onClick: onRouteToInsuranceOverview
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.userInsurances.slice(0, 3), (insurance, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["tw-w-full tw-flex tw-flex-col tw-gap-4 tw-py-4 tw-box-border", {
            'tw-border-b-dashed-custom':
              index !== props.userInsurances.slice(0, 3).length - 1,
            '!tw-pt-0': index === 0,
          }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(Text, {
                    variant: "h6",
                    lineHeight: "18px",
                    textAlign: "left",
                    class: "md:!tw-text-[.9rem]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(insurance?.metadata?.insuranceName ||
                    insurance?.insurance?.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (
                    insurance?.userVerificationStatus ===
                      _unref(UserVerificationStatusEnum).PENDING_VERIFICATION &&
                    !_unref(isExpiredDate)(insurance?.metadata?.expiryDate)
                  )
                    ? (_openBlock(), _createBlock(PendingChip, {
                        key: 0,
                        class: "tw-w-[auto]",
                        label: "Pending Verification"
                      }))
                    : _createCommentVNode("", true),
                  (
                    insurance?.userVerificationStatus ===
                      _unref(UserVerificationStatusEnum).VERIFIED &&
                    !_unref(isExpiredDate)(insurance?.metadata?.expiryDate) &&
                    !isUserProprtyOwner.value
                  )
                    ? (_openBlock(), _createBlock(AcceptChip, {
                        key: 1,
                        class: "tw-w-[auto]",
                        label: "Accepted"
                      }))
                    : _createCommentVNode("", true),
                  (
                    insurance?.userVerificationStatus ===
                      _unref(UserVerificationStatusEnum).VERIFIED &&
                    !_unref(isExpiredDate)(insurance?.metadata?.expiryDate) &&
                    isUserProprtyOwner.value
                  )
                    ? (_openBlock(), _createBlock(AcceptChip, {
                        key: 2,
                        class: "tw-w-[auto]",
                        label: "Verified"
                      }))
                    : _createCommentVNode("", true),
                  (
                    insurance?.userVerificationStatus ===
                      _unref(UserVerificationStatusEnum).REJECTED &&
                    !_unref(isExpiredDate)(insurance?.metadata?.expiryDate)
                  )
                    ? (_openBlock(), _createBlock(RejectChip, {
                        key: 3,
                        class: "tw-w-[auto]",
                        label: "Rejected"
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isExpiredDate)(insurance?.metadata?.expiryDate))
                    ? (_openBlock(), _createBlock(RejectChip, {
                        key: 4,
                        class: "tw-w-[auto]",
                        label: "Expired"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(Text, {
                  variant: "p",
                  textColor: "rgba(12, 15, 74, 0.8)",
                  lineHeight: "18px",
                  textAlign: "left",
                  class: "md:!tw-text-[.7rem]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Coverage: " + _toDisplayString(_unref(appFilters).formatToCurrency(insurance?.metadata?.sum)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(Text, {
                  variant: "p",
                  textColor: "rgba(12, 15, 74, 0.8)",
                  lineHeight: "18px",
                  textAlign: "left",
                  class: "md:!tw-text-[.7rem]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Expiry: " + _toDisplayString(_unref(appFilters).formatToDate(insurance?.metadata?.expiryDate)), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["hideFooter", "emptyStateLabel", "isEmpty", "numberOfRemainingItem", "isCustomActionHeader"]))
}
}

})